<template>
  <div class="w-full">
    <div @click="isOpen = !isOpen" class="flex items-center justify-between font-bold py-2 border-b cursor-pointer">
      {{ label }}
      <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"/>
      </svg>
    </div>
    <div v-if="isOpen" class="mt-1 space-y-2 pl-4">
      <router-link
        v-for="(link, i) in links"
        :key="i"
        :to="link.to"
        class="block text-sm hover:text-thenti-500"
        @click="$emit('close')"
      >
        {{ link.label }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
defineProps(['label', 'links']);
const isOpen = ref(false);
</script>